
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $d8bf78f2b5ef2882$export$2e2bcd8739ae039(array) {
    if (!Array.isArray(array)) throw new TypeError(`Expected an array, got ${typeof array}`);
    array = [
        ...array
    ];
    for(let index = array.length - 1; index > 0; index--){
        const newIndex = Math.floor(Math.random() * (index + 1));
        [array[index], array[newIndex]] = [
            array[newIndex],
            array[index]
        ];
    }
    return array;
}


/**
 * Fuse.js v7.0.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2023 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $39e2a8da47246292$var$isArray(value) {
    return !Array.isArray ? $39e2a8da47246292$var$getTag(value) === "[object Array]" : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $39e2a8da47246292$var$INFINITY = 1 / 0;
function $39e2a8da47246292$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    let result = value + "";
    return result == "0" && 1 / value == -$39e2a8da47246292$var$INFINITY ? "-0" : result;
}
function $39e2a8da47246292$var$toString(value) {
    return value == null ? "" : $39e2a8da47246292$var$baseToString(value);
}
function $39e2a8da47246292$var$isString(value) {
    return typeof value === "string";
}
function $39e2a8da47246292$var$isNumber(value) {
    return typeof value === "number";
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $39e2a8da47246292$var$isBoolean(value) {
    return value === true || value === false || $39e2a8da47246292$var$isObjectLike(value) && $39e2a8da47246292$var$getTag(value) == "[object Boolean]";
}
function $39e2a8da47246292$var$isObject(value) {
    return typeof value === "object";
}
// Checks if `value` is object-like.
function $39e2a8da47246292$var$isObjectLike(value) {
    return $39e2a8da47246292$var$isObject(value) && value !== null;
}
function $39e2a8da47246292$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $39e2a8da47246292$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $39e2a8da47246292$var$getTag(value) {
    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
const $39e2a8da47246292$var$EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
const $39e2a8da47246292$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $39e2a8da47246292$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $39e2a8da47246292$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $39e2a8da47246292$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $39e2a8da47246292$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $39e2a8da47246292$var$hasOwn = Object.prototype.hasOwnProperty;
class $39e2a8da47246292$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $39e2a8da47246292$var$createKey(key);
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $39e2a8da47246292$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($39e2a8da47246292$var$isString(key) || $39e2a8da47246292$var$isArray(key)) {
        src = key;
        path = $39e2a8da47246292$var$createKeyPath(key);
        id = $39e2a8da47246292$var$createKeyId(key);
    } else {
        if (!$39e2a8da47246292$var$hasOwn.call(key, "name")) throw new Error($39e2a8da47246292$var$MISSING_KEY_PROPERTY("name"));
        const name = key.name;
        src = name;
        if ($39e2a8da47246292$var$hasOwn.call(key, "weight")) {
            weight = key.weight;
            if (weight <= 0) throw new Error($39e2a8da47246292$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $39e2a8da47246292$var$createKeyPath(name);
        id = $39e2a8da47246292$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $39e2a8da47246292$var$createKeyPath(key) {
    return $39e2a8da47246292$var$isArray(key) ? key : key.split(".");
}
function $39e2a8da47246292$var$createKeyId(key) {
    return $39e2a8da47246292$var$isArray(key) ? key.join(".") : key;
}
function $39e2a8da47246292$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$39e2a8da47246292$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$39e2a8da47246292$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($39e2a8da47246292$var$isString(value) || $39e2a8da47246292$var$isNumber(value) || $39e2a8da47246292$var$isBoolean(value))) list.push($39e2a8da47246292$var$toString(value));
            else if ($39e2a8da47246292$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $39e2a8da47246292$var$isString(path) ? path.split(".") : path, 0);
    return arr ? list : list[0];
}
const $39e2a8da47246292$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $39e2a8da47246292$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $39e2a8da47246292$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $39e2a8da47246292$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $39e2a8da47246292$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $39e2a8da47246292$var$Config = {
    ...$39e2a8da47246292$var$BasicOptions,
    ...$39e2a8da47246292$var$MatchOptions,
    ...$39e2a8da47246292$var$FuzzyOptions,
    ...$39e2a8da47246292$var$AdvancedOptions
};
const $39e2a8da47246292$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $39e2a8da47246292$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($39e2a8da47246292$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $39e2a8da47246292$var$FuseIndex {
    constructor({ getFn: getFn = $39e2a8da47246292$var$Config.getFn, fieldNormWeight: fieldNormWeight = $39e2a8da47246292$var$Config.fieldNormWeight } = {}){
        this.norm = $39e2a8da47246292$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($39e2a8da47246292$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($39e2a8da47246292$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$39e2a8da47246292$var$isDefined(doc) || $39e2a8da47246292$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$39e2a8da47246292$var$isDefined(value)) return;
            if ($39e2a8da47246292$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$39e2a8da47246292$var$isDefined(value)) continue;
                    if ($39e2a8da47246292$var$isString(value) && !$39e2a8da47246292$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($39e2a8da47246292$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($39e2a8da47246292$var$isString(value) && !$39e2a8da47246292$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $39e2a8da47246292$var$createIndex(keys, docs, { getFn: getFn = $39e2a8da47246292$var$Config.getFn, fieldNormWeight: fieldNormWeight = $39e2a8da47246292$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $39e2a8da47246292$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($39e2a8da47246292$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $39e2a8da47246292$var$parseIndex(data, { getFn: getFn = $39e2a8da47246292$var$Config.getFn, fieldNormWeight: fieldNormWeight = $39e2a8da47246292$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $39e2a8da47246292$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $39e2a8da47246292$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $39e2a8da47246292$var$Config.distance, ignoreLocation: ignoreLocation = $39e2a8da47246292$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $39e2a8da47246292$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $39e2a8da47246292$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $39e2a8da47246292$var$MAX_BITS = 32;
function $39e2a8da47246292$var$search(text, pattern, patternAlphabet, { location: location = $39e2a8da47246292$var$Config.location, distance: distance = $39e2a8da47246292$var$Config.distance, threshold: threshold = $39e2a8da47246292$var$Config.threshold, findAllMatches: findAllMatches = $39e2a8da47246292$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $39e2a8da47246292$var$Config.minMatchCharLength, includeMatches: includeMatches = $39e2a8da47246292$var$Config.includeMatches, ignoreLocation: ignoreLocation = $39e2a8da47246292$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $39e2a8da47246292$var$MAX_BITS) throw new Error($39e2a8da47246292$var$PATTERN_LENGTH_TOO_LARGE($39e2a8da47246292$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $39e2a8da47246292$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $39e2a8da47246292$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $39e2a8da47246292$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $39e2a8da47246292$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $39e2a8da47246292$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $39e2a8da47246292$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $39e2a8da47246292$var$BitapSearch {
    constructor(pattern, { location: location = $39e2a8da47246292$var$Config.location, threshold: threshold = $39e2a8da47246292$var$Config.threshold, distance: distance = $39e2a8da47246292$var$Config.distance, includeMatches: includeMatches = $39e2a8da47246292$var$Config.includeMatches, findAllMatches: findAllMatches = $39e2a8da47246292$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $39e2a8da47246292$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $39e2a8da47246292$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $39e2a8da47246292$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $39e2a8da47246292$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $39e2a8da47246292$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $39e2a8da47246292$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $39e2a8da47246292$var$MAX_BITS), i);
                i += $39e2a8da47246292$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $39e2a8da47246292$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $39e2a8da47246292$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $39e2a8da47246292$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $39e2a8da47246292$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $39e2a8da47246292$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $39e2a8da47246292$var$ExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "exact";
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $39e2a8da47246292$var$InverseExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $39e2a8da47246292$var$PrefixExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "prefix-exact";
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $39e2a8da47246292$var$InversePrefixExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-prefix-exact";
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $39e2a8da47246292$var$SuffixExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "suffix-exact";
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $39e2a8da47246292$var$InverseSuffixExactMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "inverse-suffix-exact";
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $39e2a8da47246292$var$FuzzyMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern, { location: location = $39e2a8da47246292$var$Config.location, threshold: threshold = $39e2a8da47246292$var$Config.threshold, distance: distance = $39e2a8da47246292$var$Config.distance, includeMatches: includeMatches = $39e2a8da47246292$var$Config.includeMatches, findAllMatches: findAllMatches = $39e2a8da47246292$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $39e2a8da47246292$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $39e2a8da47246292$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $39e2a8da47246292$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $39e2a8da47246292$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return "fuzzy";
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $39e2a8da47246292$var$IncludeMatch extends $39e2a8da47246292$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return "include";
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $39e2a8da47246292$var$searchers = [
    $39e2a8da47246292$var$ExactMatch,
    $39e2a8da47246292$var$IncludeMatch,
    $39e2a8da47246292$var$PrefixExactMatch,
    $39e2a8da47246292$var$InversePrefixExactMatch,
    $39e2a8da47246292$var$InverseSuffixExactMatch,
    $39e2a8da47246292$var$SuffixExactMatch,
    $39e2a8da47246292$var$InverseExactMatch,
    $39e2a8da47246292$var$FuzzyMatch
];
const $39e2a8da47246292$var$searchersLen = $39e2a8da47246292$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $39e2a8da47246292$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $39e2a8da47246292$var$OR_TOKEN = "|";
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $39e2a8da47246292$var$parseQuery(pattern, options = {}) {
    return pattern.split($39e2a8da47246292$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($39e2a8da47246292$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $39e2a8da47246292$var$searchersLen){
                const searcher = $39e2a8da47246292$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $39e2a8da47246292$var$searchersLen){
                const searcher = $39e2a8da47246292$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $39e2a8da47246292$var$MultiMatchSet = new Set([
    $39e2a8da47246292$var$FuzzyMatch.type,
    $39e2a8da47246292$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $39e2a8da47246292$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $39e2a8da47246292$var$Config.isCaseSensitive, includeMatches: includeMatches = $39e2a8da47246292$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $39e2a8da47246292$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $39e2a8da47246292$var$Config.ignoreLocation, findAllMatches: findAllMatches = $39e2a8da47246292$var$Config.findAllMatches, location: location = $39e2a8da47246292$var$Config.location, threshold: threshold = $39e2a8da47246292$var$Config.threshold, distance: distance = $39e2a8da47246292$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $39e2a8da47246292$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($39e2a8da47246292$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $39e2a8da47246292$var$registeredSearchers = [];
function $39e2a8da47246292$var$register(...args) {
    $39e2a8da47246292$var$registeredSearchers.push(...args);
}
function $39e2a8da47246292$var$createSearcher(pattern, options) {
    for(let i = 0, len = $39e2a8da47246292$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $39e2a8da47246292$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $39e2a8da47246292$var$BitapSearch(pattern, options);
}
const $39e2a8da47246292$var$LogicalOperator = {
    AND: "$and",
    OR: "$or"
};
const $39e2a8da47246292$var$KeyType = {
    PATH: "$path",
    PATTERN: "$val"
};
const $39e2a8da47246292$var$isExpression = (query)=>!!(query[$39e2a8da47246292$var$LogicalOperator.AND] || query[$39e2a8da47246292$var$LogicalOperator.OR]);
const $39e2a8da47246292$var$isPath = (query)=>!!query[$39e2a8da47246292$var$KeyType.PATH];
const $39e2a8da47246292$var$isLeaf = (query)=>!$39e2a8da47246292$var$isArray(query) && $39e2a8da47246292$var$isObject(query) && !$39e2a8da47246292$var$isExpression(query);
const $39e2a8da47246292$var$convertToExplicit = (query)=>({
        [$39e2a8da47246292$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $39e2a8da47246292$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $39e2a8da47246292$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$39e2a8da47246292$var$isExpression(query)) return next($39e2a8da47246292$var$convertToExplicit(query));
        if ($39e2a8da47246292$var$isLeaf(query)) {
            const key = isQueryPath ? query[$39e2a8da47246292$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$39e2a8da47246292$var$KeyType.PATTERN] : query[key];
            if (!$39e2a8da47246292$var$isString(pattern)) throw new Error($39e2a8da47246292$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $39e2a8da47246292$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $39e2a8da47246292$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($39e2a8da47246292$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$39e2a8da47246292$var$isExpression(query)) query = $39e2a8da47246292$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $39e2a8da47246292$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $39e2a8da47246292$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $39e2a8da47246292$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$39e2a8da47246292$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$39e2a8da47246292$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $39e2a8da47246292$var$transformScore(result, data) {
    data.score = result.score;
}
function $39e2a8da47246292$var$format(results, docs, { includeMatches: includeMatches = $39e2a8da47246292$var$Config.includeMatches, includeScore: includeScore = $39e2a8da47246292$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($39e2a8da47246292$var$transformMatches);
    if (includeScore) transformers.push($39e2a8da47246292$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $39e2a8da47246292$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$39e2a8da47246292$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $39e2a8da47246292$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $39e2a8da47246292$var$FuseIndex)) throw new Error($39e2a8da47246292$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $39e2a8da47246292$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$39e2a8da47246292$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $39e2a8da47246292$var$isString(query) ? $39e2a8da47246292$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $39e2a8da47246292$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($39e2a8da47246292$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $39e2a8da47246292$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $39e2a8da47246292$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$39e2a8da47246292$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $39e2a8da47246292$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $39e2a8da47246292$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($39e2a8da47246292$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $39e2a8da47246292$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$39e2a8da47246292$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$39e2a8da47246292$var$isDefined(value)) return [];
        let matches = [];
        if ($39e2a8da47246292$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$39e2a8da47246292$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$39e2a8da47246292$export$2e2bcd8739ae039.version = "7.0.0";
$39e2a8da47246292$export$2e2bcd8739ae039.createIndex = $39e2a8da47246292$var$createIndex;
$39e2a8da47246292$export$2e2bcd8739ae039.parseIndex = $39e2a8da47246292$var$parseIndex;
$39e2a8da47246292$export$2e2bcd8739ae039.config = $39e2a8da47246292$var$Config;
$39e2a8da47246292$export$2e2bcd8739ae039.parseQuery = $39e2a8da47246292$var$parse;
$39e2a8da47246292$var$register($39e2a8da47246292$var$ExtendedSearch);


var $9397b7156c96844d$exports = {};
$9397b7156c96844d$exports = JSON.parse('[{"id":1,"name":"Bulbasaur","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/001.png","description":"Bulbasaur can be seen napping in bright sunlight. There is a seed on its back.","link":"https://www.pokemon.com/us/pokedex/bulbasaur","abilities":["Overgrow","Chlorophyll"]},{"id":2,"name":"Charmander","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/004.png","description":"Charmander\'s flame on the tip of its tail indicates its life force.","link":"https://www.pokemon.com/us/pokedex/charmander","abilities":["Blaze","Solar Power"]},{"id":3,"name":"Squirtle","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/007.png","description":"Squirtle\'s shell helps it minimize damage from attacks.","link":"https://www.pokemon.com/us/pokedex/squirtle","abilities":["Torrent","Rain Dish"]},{"id":4,"name":"Pikachu","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/025.png","description":"Pikachu generates electricity in the electric pouches on its cheeks.","link":"https://www.pokemon.com/us/pokedex/pikachu","abilities":["Static","Lightning Rod"]},{"id":5,"name":"Jigglypuff","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/039.png","description":"Jigglypuff\'s songs put people to sleep with a gentle melody.","link":"https://www.pokemon.com/us/pokedex/jigglypuff","abilities":["Cute Charm","Competitive"]},{"id":6,"name":"Meowth","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/052.png","description":"Meowth loves anything that shines. It wanders the streets looking for loose change.","link":"https://www.pokemon.com/us/pokedex/meowth","abilities":["Pickup","Technician"]},{"id":7,"name":"Psyduck","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/054.png","description":"Psyduck suffers frequent headaches, making it unable to think clearly.","link":"https://www.pokemon.com/us/pokedex/psyduck","abilities":["Damp","Cloud Nine"]},{"id":8,"name":"Machop","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/066.png","description":"Machop trains by lifting Gravelers every day.","link":"https://www.pokemon.com/us/pokedex/machop","abilities":["Guts","No Guard"]},{"id":9,"name":"Geodude","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/074.png","description":"Geodude climbs mountain paths using its arms.","link":"https://www.pokemon.com/us/pokedex/geodude","abilities":["Rock Head","Sturdy"]},{"id":10,"name":"Eevee","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/133.png","description":"Eevee has an unstable genetic makeup that suddenly mutates due to the environment.","link":"https://www.pokemon.com/us/pokedex/eevee","abilities":["Adaptability","Run Away"]},{"id":11,"name":"Snorlax","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/143.png","description":"Snorlax eats nearly 900 pounds of food every day.","link":"https://www.pokemon.com/us/pokedex/snorlax","abilities":["Immunity","Thick Fat"]},{"id":12,"name":"Mewtwo","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/150.png","description":"Mewtwo was created by recombining Mew\'s genes and is known for its psychic abilities.","link":"https://www.pokemon.com/us/pokedex/mewtwo","abilities":["Pressure","Unnerve"]},{"id":13,"name":"Oddish","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/043.png","description":"Oddish grows by absorbing moonlight. During the day, it buries itself in the ground.","link":"https://www.pokemon.com/us/pokedex/oddish","abilities":["Chlorophyll","Run Away"]},{"id":14,"name":"Vulpix","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/037.png","description":"Vulpix\'s six beautiful tails gain more warmth as it matures.","link":"https://www.pokemon.com/us/pokedex/vulpix","abilities":["Flash Fire","Drought"]},{"id":15,"name":"Growlithe","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/058.png","description":"Growlithe has a keen sense of smell and will never forget any scent.","link":"https://www.pokemon.com/us/pokedex/growlithe","abilities":["Intimidate","Flash Fire"]},{"id":16,"name":"Abra","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/063.png","description":"Abra sleeps 18 hours a day, using telepathy to sense danger while sleeping.","link":"https://www.pokemon.com/us/pokedex/abra","abilities":["Synchronize","Inner Focus"]},{"id":17,"name":"Gengar","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/094.png","description":"Gengar is said to emerge from shadows to steal the lives of those who become lost in the mountains.","link":"https://www.pokemon.com/us/pokedex/gengar","abilities":["Cursed Body","Levitate"]},{"id":18,"name":"Onix","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/095.png","description":"Onix burrows underground at high speeds and can create tunnels as it goes.","link":"https://www.pokemon.com/us/pokedex/onix","abilities":["Rock Head","Sturdy"]},{"id":19,"name":"Lapras","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/131.png","description":"Lapras ferries people across bodies of water with its gentle temperament.","link":"https://www.pokemon.com/us/pokedex/lapras","abilities":["Water Absorb","Shell Armor"]},{"id":20,"name":"Dragonite","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/149.png","description":"Dragonite can fly faster than the speed of sound and is known for its intelligence.","link":"https://www.pokemon.com/us/pokedex/dragonite","abilities":["Inner Focus","Multiscale"]},{"id":21,"name":"Magikarp","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/129.png","description":"Magikarp is virtually useless in battle but evolves into the powerful Gyarados.","link":"https://www.pokemon.com/us/pokedex/magikarp","abilities":["Swift Swim","Rain Dish"]},{"id":22,"name":"Rhyhorn","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/111.png","description":"Rhyhorn charges in a straight line, smashing everything in its path.","link":"https://www.pokemon.com/us/pokedex/rhyhorn","abilities":["Rock Head","Lightning Rod"]},{"id":23,"name":"Jynx","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/124.png","description":"Jynx\'s weird forms of communication sound similar to human speech.","link":"https://www.pokemon.com/us/pokedex/jynx","abilities":["Oblivious","Forewarn"]},{"id":24,"name":"Sandshrew","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/027.png","description":"Sandshrew\'s body is covered by a hard shell that protects it from attacks.","link":"https://www.pokemon.com/us/pokedex/sandshrew","abilities":["Sand Veil","Pickpocket"]},{"id":25,"name":"Poliwag","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/060.png","description":"Poliwag\'s skin is so thin that you can see the spiral intestines inside.","link":"https://www.pokemon.com/us/pokedex/poliwag","abilities":["Water Absorb","Swift Swim"]},{"id":26,"name":"Zubat","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/041.png","description":"Zubat uses ultrasonic waves to detect obstacles and navigate in the dark.","link":"https://www.pokemon.com/us/pokedex/zubat","abilities":["Inner Focus","Infiltrator"]},{"id":27,"name":"Pidgey","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/016.png","description":"Pidgey can easily be found in grassy areas and forests.","link":"https://www.pokemon.com/us/pokedex/pidgey","abilities":["Keen Eye","Tangled Feet"]},{"id":28,"name":"Rattata","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/019.png","description":"Rattata\'s sharp fangs can easily bite through tough materials.","link":"https://www.pokemon.com/us/pokedex/rattata","abilities":["Run Away","Guts"]},{"id":29,"name":"Machoke","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/067.png","description":"Machoke\'s muscles are strong enough to throw a hundred adult humans.","link":"https://www.pokemon.com/us/pokedex/machoke","abilities":["Guts","No Guard"]},{"id":30,"name":"Golbat","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/042.png","description":"Golbat is known for its sharp fangs and its ability to suck blood.","link":"https://www.pokemon.com/us/pokedex/golbat","abilities":["Inner Focus","Infiltrator"]},{"id":31,"name":"Pidgeotto","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/017.png","description":"Pidgeotto is a fierce and territorial Pok\xe9mon.","link":"https://www.pokemon.com/us/pokedex/pidgeotto","abilities":["Keen Eye","Tangled Feet"]},{"id":32,"name":"Fearow","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/022.png","description":"Fearow\'s cry can be heard from over a mile away.","link":"https://www.pokemon.com/us/pokedex/fearow","abilities":["Keen Eye","Sniper"]},{"id":33,"name":"Seel","image":"https://assets.pokemon.com/assets/cms2/img/pokedex/full/086.png","description":"Seel\'s body is covered in a thick layer of blubber.","link":"https://www.pokemon.com/us/pokedex/seel","abilities":["Thick Fat","Hydration"]}]');



function $f9c52bd6e950abe1$export$2e2bcd8739ae039(data) {
    // obj destructuring
    const { image: image, link: link, description: description, name: name } = data;
    const div = document.createElement("div");
    div.classList.add("col");
    div.innerHTML = `
      <div class="card">
          <img src="${image}" class="card-img-top" alt="${name}" loding="lazy">
          <div class="card-body">
            <h5 class="card-title">${name}</h5>
            <p class="card-text">${description}</p>
            ${link ? `<a class="btn btn-primary" href="${link}" role="button">Visit</a>` : ""}

    </div>`;
    return div;
}


// DOM targeting
const $e366f2c43bf887ab$var$inputEl = document.querySelector("input");
const $e366f2c43bf887ab$var$dataRow = document.querySelector("[data-row]");
$e366f2c43bf887ab$var$renderPokemon((0, $d8bf78f2b5ef2882$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($9397b7156c96844d$exports)))));
// Function for rendering Pokemon cards
function $e366f2c43bf887ab$var$renderPokemon(list) {
    $e366f2c43bf887ab$var$dataRow.textContent = "";
    if (!list.length) {
        const pokemon = (0, $f9c52bd6e950abe1$export$2e2bcd8739ae039)({
            image: "https://static1.cbrimages.com/wordpress/wp-content/uploads/2022/08/Ash-Pokemon.jpg",
            name: "Not Found",
            description: "Try another search"
        });
        $e366f2c43bf887ab$var$dataRow.appendChild(pokemon);
        return;
    }
    const fragment = document.createDocumentFragment();
    list.forEach((pokemonObj)=>{
        const pokemon = (0, $f9c52bd6e950abe1$export$2e2bcd8739ae039)(pokemonObj);
        fragment.appendChild(pokemon);
    });
    $e366f2c43bf887ab$var$dataRow.appendChild(fragment);
}
// Function to perform search
function $e366f2c43bf887ab$var$performSearch(input) {
    const options = {
        keys: [
            "name",
            "abilities"
        ],
        threshold: 0.5
    };
    const fuse = new (0, $39e2a8da47246292$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($9397b7156c96844d$exports))), options);
    if (!input) return 0, (/*@__PURE__*/$parcel$interopDefault($9397b7156c96844d$exports));
    const searched = fuse.search(input);
    return searched.map((obj)=>obj.item);
}
// Debounce logic
let $e366f2c43bf887ab$var$debounceTimer;
$e366f2c43bf887ab$var$inputEl.addEventListener("input", (e)=>{
    const target = e.target;
    clearTimeout($e366f2c43bf887ab$var$debounceTimer);
    $e366f2c43bf887ab$var$debounceTimer = setTimeout(()=>{
        const filteredPokemon = $e366f2c43bf887ab$var$performSearch(target.value.trim().toLowerCase());
        $e366f2c43bf887ab$var$renderPokemon(filteredPokemon);
    }, 600);
});
// For keyboard accessibility
document.addEventListener("keyup", (e)=>{
    if (e.key === "/") $e366f2c43bf887ab$var$inputEl.focus();
});


//# sourceMappingURL=index.1fa76506.js.map
